// ---------------------------------------------------------------------------
// QueryDevtools — renders the TanStack Query Devtools panel in dev builds only.
//
// The devtools import is code-split via React.lazy and guarded by `isDevMode`
// (a Vite build-time constant), so the devtools bundle is tree-shaken out of
// production builds entirely.
// ---------------------------------------------------------------------------

import { Suspense, lazy } from 'react';

import { isDevMode } from '../config';

const ReactQueryDevtoolsLazy = lazy(() =>
  import('@tanstack/react-query-devtools').then((mod) => ({
    default: mod.ReactQueryDevtools,
  })),
);

export function QueryDevtools() {
  if (!isDevMode) return null;
  return (
    <Suspense fallback={null}>
      <ReactQueryDevtoolsLazy initialIsOpen={false} />
    </Suspense>
  );
}
